import { useQuery } from "@tanstack/react-query";

import CONSTANTS from "constants/Constants";
import DataJobService from "services/DataJob";

const STATUS = CONSTANTS.DATA_JOB_STATUSES;
const ACTIVE_STATUSES = new Set([STATUS.SCHEDULED, STATUS.IN_PROGRESS]);
const TERMINAL_STATUSES = new Set([
  STATUS.COMPLETE,
  STATUS.COMPLETED_WITH_ERRORS,
  STATUS.FAILED,
  STATUS.ABORTED,
]);
const STALL_THRESHOLD_MS = 5 * 60 * 1000;

export const useImportJob = jobId => {
  const { data: job } = useQuery({
    queryKey: ["custom-table-import-job", jobId],
    queryFn: () => DataJobService.getDataJob(jobId),
    enabled: jobId != null,
    retry: false,
    refetchInterval: query => {
      const status = query.state.data?.status;
      if (ACTIVE_STATUSES.has(status)) return 2000;
      if (TERMINAL_STATUSES.has(status)) return 10000;
      return false;
    },
  });

  const progress = job?.info?.custom_table_import;
  const status = job?.status;
  const isComplete =
    status === STATUS.COMPLETE || status === STATUS.COMPLETED_WITH_ERRORS;
  const isAborted = status === STATUS.ABORTED;
  const isFailed = status === STATUS.FAILED || isAborted;

  // Stall detection is measured against the server clock (``server_now``)
  // returned alongside the job, not ``Date.now()`` — it's free of client
  // clock skew and depends only on the React Query ``data`` object, which
  // is referentially stable per fetch (no purity violation during render).
  let isStalled = false;
  if (progress?.last_progress_at && job?.server_now) {
    const elapsed =
      Date.parse(job.server_now) - Date.parse(progress.last_progress_at);
    isStalled = elapsed > STALL_THRESHOLD_MS;
  }

  return {
    job,
    status,
    progress,
    isComplete,
    isFailed,
    isAborted,
    isStalled,
  };
};

export default useImportJob;
